'use client';

import { css, Global } from '@emotion/core';
import { ISiteSectionEntry } from '../../contentful/types/ISiteSection';
import GenericPage, { IGenericPageProps } from '../app/pages/ui/GenericPage';
import OxdAirportEntryPoints from './OxdAirportEntryPoints';
import { Color } from '../../styles/Color';

interface IOxdAirportPageProps extends IGenericPageProps {
	siteSection?: ISiteSectionEntry;
}

export default function OxdAirportPage({
	page,
	siteSection,
}: IOxdAirportPageProps) {
	return (
		<>
			<Global
				styles={css`
					a {
						color: ${Color.OxdPrimary};
					}
				`}
			/>
			<GenericPage page={page} siteSection={siteSection} childrenFirst>
				<OxdAirportEntryPoints />
			</GenericPage>
		</>
	);
}
